import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/shipping_agencies`);
  },

  fetchDetail(portId, itemId) {
    return http.get(`${resource}/${portId}/shipping_agencies/${itemId}`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/shipping_agencies/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/shipping_agencies/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/shipping_agencies`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/shipping_agencies/${itemId}`);
  },
};
